"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
/**
 * Surface that display content and actions on a single topic.
 * @param children - React node containing the card main content.
 * @param style - Card custom styles (optional).
 * @param header - Card header (optional).
 * @param className - Styles classname (optional).
 */
function Card(_a) {
    var children = _a.children, style = _a.style, header = _a.header, className = _a.className;
    return (react_1.default.createElement(styles_1.Container, { style: style, className: className },
        header &&
            (typeof header === "string" ? react_1.default.createElement(styles_1.Header, null, header) : header),
        children));
}
exports.default = Card;
//# sourceMappingURL=index.js.map